import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'es', label: 'Español' },
];

const Select = styled.select<{ $light: boolean }>`
  background: transparent;
  border: 1px solid ${({ $light }) => ($light ? 'rgba(0,0,0,0.2)' : 'rgba(255,255,255,0.3)')};
  border-radius: 4px;
  color: ${({ $light }) => ($light ? '#1a1a2e' : '#fff')};
  font-size: 12px;
  padding: 2px 20px 2px 6px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: ${({ $light }) =>
    $light
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%231a1a2e'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%23fff'/%3E%3C/svg%3E")`};
  background-repeat: no-repeat;
  background-position: right 6px center;

  option {
    background: #fff;
    color: #1a1a2e;
  }
`;

interface LanguageSwitcherProps {
  variant?: 'light' | 'dark';
}

export const LanguageSwitcher = ({ variant = 'dark' }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.slice(0, 2);

  return (
    <Select
      $light={variant === 'light'}
      value={current}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      aria-label="Select language"
    >
      {LANGUAGES.map(({ code, label }) => (
        <option key={code} value={code}>
          {label}
        </option>
      ))}
    </Select>
  );
};
